import { fetchWithAuthorization } from '../../../helpers/fetch-with-authorization';

export type ConfirmOrderFn = (payload: {
    request: {
        orderId: string;
        stripePaymentMethodId?: string;
    };
    accessToken: string;
}) => Promise<unknown>;

export function initConfirmOrderFn({
    baseUrl,
}: {
    baseUrl: string;
}): ConfirmOrderFn {
    const href = 'order/v1/orders/{orderId}/confirm';
    return async ({
        request: { orderId, stripePaymentMethodId },
        accessToken,
    }) => {
        const url = `${baseUrl}/${href.replace('{orderId}', orderId)}`;
        const response = await fetchWithAuthorization({
            url,
            method: 'PUT',
            accessToken,
            ...(stripePaymentMethodId
                ? {
                      body: { stripePaymentMethodId },
                  }
                : {}),
        });
        if (!response.ok) return Promise.reject(await response.json());
        return response.json();
    };
}
